(function () {
  'use strict';

  angular.module('eclipseApp.onboarding').controller('onboardingItemController', OnboardingItemController);

  OnboardingItemController.$inject = ['uteModal', 'onboardingService'];

  function OnboardingItemController(uteModal, onboardingService) {
    var _this = this;
    init();

    function init() {
    }

    _this.openModal = function (event) {
      uteModal.open({
        templateUrl: 'modules/onboarding/onboarding-item/onboarding-modal.html',
        windowTemplateUrl: 'views/templates/modal/pop-up-window-modal.html',
        windowClass: 'onboarding-modal-window-class',
        backdrop: 'static',
        controller: ['$scope', function ($scope) {
          var modalVm = this;
          modalVm.titleKey = _this.config.itemKey;
          modalVm.descriptionKey = _this.config.modal.descriptionTranslationKey;
          modalVm.buttons = _this.config.modal.buttons;
          modalVm.close = function () {
            $(event.target).focus();
            $scope.$close();
          };
        }],
        controllerAs: 'ctrl'
      });
    };

    _this.openAddOrVerifyEmailModal = function (event) {
      uteModal.open({
        templateUrl: _this.config.itemKey === 'verifyContactEmail' ? 'modules/onboarding/onboarding-item/onboarding-verify-email-modal.html' : 'modules/onboarding/onboarding-item/onboarding-add-email-modal.html',
        windowTemplateUrl: 'views/templates/modal/pop-up-window-modal.html',
        windowClass: 'onboarding-modal-window-class',
        backdrop: 'static',
        controller: ['$scope', 'ute.datalayer.common.service', '$translate', '$window', function ($scope, dataLayerService, $translate, $window) {
          var modalVm = this;

          /* Flags for email verification*/
          modalVm.emailVerifiedSuccess = false;
          modalVm.emailVerifiedFailure = false;

          /* Flags for email modification */
          modalVm.changeEmail = false;
          modalVm.changeEmailFormSubmitted = false;
          modalVm.reviewScreen = false;
          modalVm.changeEmailSuccess = false;
          modalVm.changeEmailFailure = false;

          modalVm.titleKey = _this.config.itemKey === 'verifyContactEmail' ? 'onboarding-module.tasks.verifyContactEmail.modal.title' : _this.config.itemKey === 'addContactEmail' ? 'onboarding-module.tasks.addContactEmail.modal.title' : '';
          modalVm.descriptionKey = _this.config.itemKey === 'verifyContactEmail' ? 'onboarding-module.tasks.verifyContactEmail.modal.description' : _this.config.itemKey === 'addContactEmail' ? 'onboarding-module.tasks.addContactEmail.modal.description' : '';
          modalVm.contactEmail = _this.config.itemKey === 'verifyContactEmail' ? _this.config.emailAddress : null;

          /**
           * @description Function to verify existing email when user click on 'Yes, It's Correct' 
           */
          modalVm.verifyExistingEmail = function () {
            onboardingService.setServerStatus(true).then(function (response) {
              if (response.isSuccess) {
                modalVm.emailVerifiedSuccess = true;
                modalVm.emailVerifiedFailure = false;
                _this.config.completed = true;
                modalVm.titleKey = 'onboarding-module.tasks.verifyContactEmail.modal.emailSuccessfullyVerifiedTitle';
                modalVm.descriptionKey = 'onboarding-module.tasks.verifyContactEmail.modal.emailSuccessfullyVerifiedDesc';
                modalVm.trackDataLayer(_this.config.itemKey, 'emailVerified');
              } else {
                modalVm.setErrorStatus();
                modalVm.trackDataLayerError(response, 'onboarding-module.tasks.verifyContactEmail.modal.emailVerifyFailDesc');
              }
            }, function (error) {
              modalVm.setErrorStatus();
              modalVm.trackDataLayerError(error, 'onboarding-module.tasks.verifyContactEmail.modal.emailVerifyFailDesc');
            });
          };

          /**
           * @description  Function to show error screen and appropirate message when we are unable to update the onboarding status
           */
          modalVm.setErrorStatus = function () {
            _this.config.completed = false;
            modalVm.emailVerifiedSuccess = false;
            modalVm.emailVerifiedFailure = true;
            modalVm.titleKey = 'onboarding-module.sorryAboutThat';
            modalVm.descriptionKey = 'onboarding-module.tasks.verifyContactEmail.modal.emailVerifyFailDesc';
          };

          /**
           * @description  Function to show Change contact email screen, where user can enter the new email address
           */
          modalVm.changeContactEmail = function () {
            modalVm.changeEmailFormSubmitted = false;
            modalVm.changeEmail = true;
            modalVm.titleKey = 'onboarding-module.tasks.verifyContactEmail.modal.changeYourContactEmail';
            modalVm.trackDataLayer(_this.config.itemKey, 'editEmail.step1');
          };

          /**
           * @description Function to show Add contact email screen
           */
          modalVm.addContactEmail = function () {
            modalVm.titleKey = 'onboarding-module.tasks.addContactEmail.modal.title';
            modalVm.changeEmailFormSubmitted = false;
          };

          /**
           * @description  Function to show review screen if new email entered is valid
           * @param form {Object}
           */
          modalVm.reviewChangeEmail = function (form, action) {
            modalVm.changeEmailFormSubmitted = true;
            if(form.$valid){
              // show review screen
              modalVm.reviewScreen = true;
              modalVm.titleKey = 'onboarding-module.tasks.verifyContactEmail.modal.reviewContactEmail';
              modalVm.descriptionKeyReviewEmail = action === 'addEmail' ? 'onboarding-module.tasks.addContactEmail.modal.reviewContactEmailDesc' : 'onboarding-module.tasks.verifyContactEmail.modal.reviewContactEmailDesc';
              var mappingAction = action === 'addEmail' ? 'step2': 'editEmail.step2';
              modalVm.trackDataLayer(_this.config.itemKey, mappingAction);
            } else {
              modalVm.formErrorType = 'form';
              if(form.modifyEmail.$error.email || form.modifyEmail.$error.pattern) {
                modalVm.formErrorType = 'user';
              }
            }
          };

          /**
           * @description  Function to discard modifying old email and go back to previous screen
           * @param form {Object}
           * @param action {String}
           */
          modalVm.cancelChangeContactEmail = function (form, action) {
            modalVm.titleKey = action === 'addEmail'? 'onboarding-module.tasks.addContactEmail.modal.title':'onboarding-module.tasks.verifyContactEmail.modal.title';
            modalVm.changeEmail = !modalVm.changeEmail;
            form.$setPristine();
            form.$setUntouched();
            form.$submitted = false;
            modalVm.changeEmailFormSubmitted = false;
          };

          /**
           * @description Function to submit new contact email or edit existing email on file
           * @param action {String}
           */
          modalVm.submitModifiedContactEmail = function (action) {
            onboardingService.updateContactEmail(modalVm.modifyEmail).then(function (response) {
              if(response.isSuccess){
                modalVm.changeEmailSuccess = true;
                modalVm.changeEmailFailure = false;
                modalVm.titleKey = action === 'addEmail' ? 'onboarding-module.tasks.addContactEmail.modal.contactEmailAdded' : 'onboarding-module.tasks.verifyContactEmail.modal.contactEmailChanged';
                modalVm.descriptionKeyReviewEmail = action === 'addEmail' ? 'onboarding-module.tasks.addContactEmail.modal.contactEmailAddedDesc' : 'onboarding-module.tasks.verifyContactEmail.modal.contactEmailChangedDesc';
                _this.config.completed = true;
                var mappingAction = action === 'addEmail' ? 'emailAdded' : 'editEmail.emailChanged' ;
                modalVm.trackDataLayer(_this.config.itemKey, mappingAction);
                if(action === 'editEmail') {
                  // if user is changing the email though verify email task, then we need to track self serve completion for verify email task too
                  modalVm.trackDataLayer(_this.config.itemKey, 'emailVerified');
                }
              } else {
                modalVm.setAddModifyEmailErrorStatus(action);
                modalVm.trackUpdateContactInfoError (action, response);
              }
            }, function (error) {
              modalVm.setAddModifyEmailErrorStatus(action);
              modalVm.trackUpdateContactInfoError (action, error);
            });
          };

          /**
           * @description Function to track when there is any error while calling `updateContactInformation` API
           * @param action {String}
           * @param error {Object}
           */
          modalVm.trackUpdateContactInfoError = function (action, error) {
            var onScreenError = action === 'addEmail' ? 'onboarding-module.tasks.addContactEmail.modal.contactEmailNotAdded' : 'onboarding-module.tasks.verifyContactEmail.modal.contactEmailNotChanged';
            modalVm.trackDataLayerError(error, onScreenError);
          };

          /**
           * @description Function to show error screen and appropirate message when we are unable to add new or modify existing email
           * @param action {String}
           */
          modalVm.setAddModifyEmailErrorStatus = function (action) {
            modalVm.changeEmailSuccess = false;
            modalVm.changeEmailFailure = true;
            modalVm.titleKey = 'onboarding-module.sorryAboutThat';
            modalVm.descriptionKeyReviewEmail = action === 'addEmail' ? 'onboarding-module.tasks.addContactEmail.modal.contactEmailNotAdded' : 'onboarding-module.tasks.verifyContactEmail.modal.contactEmailNotChanged';
          };

          /**
           * @description  Function to close the modal and return to Account Overview 
           */
          modalVm.close = function () {
            $(event.target).focus();
            $scope.$close();
          };

          /**
           * @description  Function to close the modal and trigger Progress bar voice over
           */
          modalVm.done = function () {
            modalVm.close();
            onboardingService.triggerAlertRole();
          };

          /**
           * @description Function to track data layer
           * @param itemKey {String}
           * @param action {String}
           */
          modalVm.trackDataLayer = function (itemKey, action) {
            dataLayerService.track({}, true, [0, 1, 4], {mappingKey: 'onboarding.' + itemKey + '.' + action});
          };

          /**
           * @description Function to track API failures with context
           * @param res {Object}
           * @param errorMsg {String}
           */
          modalVm.trackDataLayerError = function (res, errorMsg) {
            try{
              var data = res.data;  
              var payload = {};
              var api = res.config.url;
              var errorType = $window.ute.datalayer.common.service.ErrorType;
              var errorCategory = $window.ute.datalayer.common.service.ErrorCategory;
              var dataLayerPredefinedSection = $window.ute.datalayer.common.service.DataLayerPredefinedSection;
              var globalObjects = [dataLayerPredefinedSection.ACCOUNT, dataLayerPredefinedSection.PAGE, dataLayerPredefinedSection.SITE, dataLayerPredefinedSection.GLOBAL];
              $translate(errorMsg).then(function(message){
                // As per Analytics docs, value of `errors.message` should be whatever the error message is that a visitor sees.
                dataLayerService.trackError(payload, errorType.HTTP, _.get(data, 'status.code') || data.error || res.status, message, errorCategory.SELF_SERVE, '', api, true, globalObjects);
              }, function (error) {
                dataLayerService.trackError(payload, errorType.HTTP, _.get(data, 'status.code') || data.error || res.status, _.get(data, 'status.codeName'), errorCategory.SELF_SERVE, '', api, true, globalObjects);
              });
            }
            catch (e) {
              console.log('Error during data layer API failure tracking::' + e );
            }
          };

        }],
        controllerAs: 'ctrl'
      });
    }

    _this.getTaskAltTranslationKey = function () {
      return 'onboarding-module.tasks.' + _this.config.itemKey + '.alt.' + (_this.config.completed ? 'completed' : 'pending');
    };
  }

})();
